module.exports = __webpack_public_path__ + "img/text-con-2.dd15c91e.png";